import InmueblesTemplate from "../../components/templates/inmuebles/InmueblesTemplate"

const Inmuebles = () => {
    return <InmueblesTemplate/>;
};

export default Inmuebles;